import classNames from 'classnames';

const KetoFriendlyIcon = ({ className = '', hcSelected = false, tempoSelected = false }) => {
  if (hcSelected) {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classNames('', className)}
        role="presentation"
        pointerEvents="none"
      >
        <title>Keto-Friendly</title>
        <path
          d="M22.8528 17.7483C22.8528 22.9694 19.6805 25.4516 16.1997 25.4516C12.719 25.4516 9.54883 22.9716 9.54883 17.7483C9.54883 12.525 12.7205 6.54248 16.2019 6.54248C19.6834 6.54248 22.8528 12.5287 22.8528 17.7483Z"
          className="fill-green-70"
        />
        <path
          d="M16.2 26C12.6167 26 9 23.4495 9 17.7506C9 12.4276 12.2116 6 16.2 6C20.1884 6 23.4 12.4276 23.4 17.7506C23.3985 23.4495 19.7825 26 16.2 26ZM16.2 7.09091C13.2313 7.09091 10.0909 12.5702 10.0909 17.7506C10.0909 23.0335 13.3818 24.9091 16.2 24.9091C19.0182 24.9091 22.3091 23.0335 22.3091 17.7506C22.3076 12.5702 19.168 7.09091 16.2 7.09091Z"
          className="fill-green-130"
        />
        <path
          d="M16.1999 22.1418C18.0484 22.1418 19.5468 20.6434 19.5468 18.7949C19.5468 16.9465 18.0484 15.448 16.1999 15.448C14.3515 15.448 12.853 16.9465 12.853 18.7949C12.853 20.6434 14.3515 22.1418 16.1999 22.1418Z"
          className="fill-green-130"
        />
        <path
          d="M16.2 22.6872C15.4301 22.6872 14.6776 22.4589 14.0375 22.0312C13.3974 21.6035 12.8985 20.9956 12.6039 20.2844C12.3093 19.5731 12.2322 18.7905 12.3824 18.0355C12.5326 17.2804 12.9033 16.5869 13.4477 16.0425C13.992 15.4982 14.6856 15.1274 15.4406 14.9773C16.1957 14.8271 16.9783 14.9042 17.6895 15.1988C18.4008 15.4934 19.0087 15.9923 19.4364 16.6324C19.8641 17.2724 20.0923 18.025 20.0923 18.7948C20.0912 19.8268 19.6807 20.8162 18.951 21.5459C18.2213 22.2756 17.2319 22.686 16.2 22.6872ZM16.2 15.9963C15.6459 15.9963 15.1043 16.1606 14.6436 16.4684C14.1829 16.7763 13.8238 17.2138 13.6118 17.7257C13.3997 18.2376 13.3443 18.8008 13.4524 19.3443C13.5605 19.8877 13.8273 20.3869 14.2191 20.7787C14.6108 21.1705 15.11 21.4373 15.6534 21.5454C16.1969 21.6535 16.7602 21.598 17.272 21.3859C17.7839 21.1739 18.2215 20.8148 18.5293 20.3541C18.8371 19.8934 19.0014 19.3518 19.0014 18.7977C19.0014 18.0545 18.7064 17.3416 18.1811 16.8158C17.6558 16.29 16.9432 15.9941 16.2 15.9934V15.9963Z"
          className="fill-green-130"
        />
      </svg>
    );
  } else if (tempoSelected) {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classNames('', className)}
        role="presentation"
        pointerEvents="none"
      >
        <title>Keto-Friendly</title>
        <path
          d="M22.8528 17.7483C22.8528 22.9694 19.6805 25.4516 16.1997 25.4516C12.719 25.4516 9.54883 22.9716 9.54883 17.7483C9.54883 12.525 12.7205 6.54248 16.2019 6.54248C19.6834 6.54248 22.8528 12.5287 22.8528 17.7483Z"
          className="fill-tempo-blue-70"
        />
        <path
          d="M16.2 26C12.6167 26 9 23.4495 9 17.7506C9 12.4276 12.2116 6 16.2 6C20.1884 6 23.4 12.4276 23.4 17.7506C23.3985 23.4495 19.7825 26 16.2 26ZM16.2 7.09091C13.2313 7.09091 10.0909 12.5702 10.0909 17.7506C10.0909 23.0335 13.3818 24.9091 16.2 24.9091C19.0182 24.9091 22.3091 23.0335 22.3091 17.7506C22.3076 12.5702 19.168 7.09091 16.2 7.09091Z"
          className="fill-tempo-blue-120"
        />
        <path
          d="M16.1999 22.1418C18.0484 22.1418 19.5468 20.6434 19.5468 18.7949C19.5468 16.9465 18.0484 15.448 16.1999 15.448C14.3515 15.448 12.853 16.9465 12.853 18.7949C12.853 20.6434 14.3515 22.1418 16.1999 22.1418Z"
          className="fill-tempo-blue-120"
        />
        <path
          d="M16.2 22.6872C15.4301 22.6872 14.6776 22.4589 14.0375 22.0312C13.3974 21.6035 12.8985 20.9956 12.6039 20.2844C12.3093 19.5731 12.2322 18.7905 12.3824 18.0355C12.5326 17.2804 12.9033 16.5869 13.4477 16.0425C13.992 15.4982 14.6856 15.1274 15.4406 14.9773C16.1957 14.8271 16.9783 14.9042 17.6895 15.1988C18.4008 15.4934 19.0087 15.9923 19.4364 16.6324C19.8641 17.2724 20.0923 18.025 20.0923 18.7948C20.0912 19.8268 19.6807 20.8162 18.951 21.5459C18.2213 22.2756 17.2319 22.686 16.2 22.6872ZM16.2 15.9963C15.6459 15.9963 15.1043 16.1606 14.6436 16.4684C14.1829 16.7763 13.8238 17.2138 13.6118 17.7257C13.3997 18.2376 13.3443 18.8008 13.4524 19.3443C13.5605 19.8877 13.8273 20.3869 14.2191 20.7787C14.6108 21.1705 15.11 21.4373 15.6534 21.5454C16.1969 21.6535 16.7602 21.598 17.272 21.3859C17.7839 21.1739 18.2215 20.8148 18.5293 20.3541C18.8371 19.8934 19.0014 19.3518 19.0014 18.7977C19.0014 18.0545 18.7064 17.3416 18.1811 16.8158C17.6558 16.29 16.9432 15.9941 16.2 15.9934V15.9963Z"
          className="fill-tempo-blue-120"
        />
      </svg>
    );
  } else {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classNames('', className)}
        role="presentation"
        pointerEvents="none"
      >
        <title>Keto-Friendly</title>
        <path
          d="M22.8528 17.7483C22.8528 22.9694 19.6805 25.4516 16.1997 25.4516C12.719 25.4516 9.54883 22.9716 9.54883 17.7483C9.54883 12.525 12.7205 6.54248 16.2019 6.54248C19.6834 6.54248 22.8528 12.5287 22.8528 17.7483Z"
          fill="transparent"
        />
        <path
          d="M16.2 26C12.6167 26 9 23.4495 9 17.7506C9 12.4276 12.2116 6 16.2 6C20.1884 6 23.4 12.4276 23.4 17.7506C23.3985 23.4495 19.7825 26 16.2 26ZM16.2 7.09091C13.2313 7.09091 10.0909 12.5702 10.0909 17.7506C10.0909 23.0335 13.3818 24.9091 16.2 24.9091C19.0182 24.9091 22.3091 23.0335 22.3091 17.7506C22.3076 12.5702 19.168 7.09091 16.2 7.09091Z"
          fill="#4A4A4A"
        />
        <path
          d="M16.1999 22.1418C18.0484 22.1418 19.5468 20.6434 19.5468 18.7949C19.5468 16.9465 18.0484 15.448 16.1999 15.448C14.3515 15.448 12.853 16.9465 12.853 18.7949C12.853 20.6434 14.3515 22.1418 16.1999 22.1418Z"
          fill="#4A4A4A"
        />
        <path
          d="M16.2 22.6872C15.4301 22.6872 14.6776 22.4589 14.0375 22.0312C13.3974 21.6035 12.8985 20.9956 12.6039 20.2844C12.3093 19.5731 12.2322 18.7905 12.3824 18.0355C12.5326 17.2804 12.9033 16.5869 13.4477 16.0425C13.992 15.4982 14.6856 15.1274 15.4406 14.9773C16.1957 14.8271 16.9783 14.9042 17.6895 15.1988C18.4008 15.4934 19.0087 15.9923 19.4364 16.6324C19.8641 17.2724 20.0923 18.025 20.0923 18.7948C20.0912 19.8268 19.6807 20.8162 18.951 21.5459C18.2213 22.2756 17.2319 22.686 16.2 22.6872ZM16.2 15.9963C15.6459 15.9963 15.1043 16.1606 14.6436 16.4684C14.1829 16.7763 13.8238 17.2138 13.6118 17.7257C13.3997 18.2376 13.3443 18.8008 13.4524 19.3443C13.5605 19.8877 13.8273 20.3869 14.2191 20.7787C14.6108 21.1705 15.11 21.4373 15.6534 21.5454C16.1969 21.6535 16.7602 21.598 17.272 21.3859C17.7839 21.1739 18.2215 20.8148 18.5293 20.3541C18.8371 19.8934 19.0014 19.3518 19.0014 18.7977C19.0014 18.0545 18.7064 17.3416 18.1811 16.8158C17.6558 16.29 16.9432 15.9941 16.2 15.9934V15.9963Z"
          fill="#4A4A4A"
        />
      </svg>
    );
  }
};

KetoFriendlyIcon.propTypes = {
  className: PropTypes.string,
  hcSelected: PropTypes.bool,
  tempoSelected: PropTypes.bool,
};

export default KetoFriendlyIcon;
